export interface Box {
  top: number;
  left: number;
  width: number;
  height: number;
}
export interface Placement {
  top: number;
  left: number;
}

const GAP = 4;

/**
 * Where a hover card goes: below its trigger when it fits, else above, else
 * beside it (right, then left), and as a last resort pinned inside the
 * viewport next to the trigger. The card is never cut off by a viewport edge.
 */
export function placeHoverCard(
  anchor: Box,
  size: { width: number; height: number },
  viewport: { width: number; height: number },
  margin: number,
): Placement {
  const clampLeft = (left: number) =>
    Math.max(margin, Math.min(left, viewport.width - size.width - margin));
  const clampTop = (top: number) =>
    Math.max(margin, Math.min(top, viewport.height - size.height - margin));
  const anchorBottom = anchor.top + anchor.height;
  const anchorRight = anchor.left + anchor.width;
  if (anchorBottom + GAP + size.height <= viewport.height - margin)
    return { top: anchorBottom + GAP, left: clampLeft(anchor.left) };
  if (anchor.top - GAP - size.height >= margin)
    return { top: anchor.top - GAP - size.height, left: clampLeft(anchor.left) };
  if (anchorRight + GAP + size.width <= viewport.width - margin)
    return { top: clampTop(anchor.top), left: anchorRight + GAP };
  if (anchor.left - GAP - size.width >= margin)
    return { top: clampTop(anchor.top), left: anchor.left - GAP - size.width };
  return { top: clampTop(anchor.top), left: clampLeft(anchor.left) };
}
